export enum UnitOfMeasure {
    SI,
    Imperial,
}

export enum EProjectType {
    Macra1,
    Macra2,
    VerticalDrop = 2,
    SteppedWeir = 4,
    SlopedWeir = 8,
}
